// extracted by mini-css-extract-plugin
export var card = "addresses-module--card--dwKH7";
export var container = "addresses-module--container--QK9E2";
export var header = "addresses-module--header--1aXut";
export var headerText = "addresses-module--header-text--DB136";
export var list = "addresses-module--list--OAWdt";